import { render, staticRenderFns } from "./InformationTags.vue?vue&type=template&id=6715a9bd"
import script from "./InformationTags.vue?vue&type=script&lang=js"
export * from "./InformationTags.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports